import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgxWebstorageModule } from 'ngx-webstorage';
import 'hammerjs';
import 'intl';
import 'intl/locale-data/jsonp/en';

import { EntityService } from './data/entity.service';
import { injectJsonDelayedProperty } from './utils/decorators/json-convert';
import { ClearPhoneNumberPipe } from './utils/pipes/clear-phone-number.pipe';
import { GmapsService } from './data/gmaps/gmaps.service';
import { ErrorHandleInterceptor } from './data/interceptors/error-handle.interceptor';
import { CredentialsInterceptor } from './data/interceptors/credentials.interceptor';
import { TEInterceptor } from './data/interceptors/te.interceptor';

import * as NavigatorOverride from './overrides/navigator'; // Do not delete
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
	imports: [
		CommonModule,
		HttpClientModule,
		NgxWebstorageModule.forRoot(),
		FormsModule,
		MatSnackBarModule,
		BrowserAnimationsModule
	],
	declarations: [
		ClearPhoneNumberPipe
	],
	providers: [
		EntityService, {
			provide: HTTP_INTERCEPTORS,
			useClass: CredentialsInterceptor,
			multi: true
		}, {
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorHandleInterceptor,
			multi: true
		}, {
			provide: HTTP_INTERCEPTORS,
			useClass: TEInterceptor,
			multi: true
		},
		GmapsService
	],
	bootstrap: [],
	exports: [
		NgxWebstorageModule,
		HttpClientModule,
		FormsModule,
		MatSnackBarModule,
		BrowserAnimationsModule,
		ClearPhoneNumberPipe
	]
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error('CoreModule is already loaded. Import it in the AppModule only');
		}

		injectJsonDelayedProperty();
	}
}
